// Polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueRouter from 'vue-router'
// import VueRouter from 'vue-router'
import {
  BootstrapVue,
  IconsPlugin
} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import i18n from './plugins/i18n/index';

import GA from './components/CustomGoogleAnalytics.js'

import VueCookies from 'vue-cookies'

import browserDetect from "vue-browser-detect-plugin";

Vue.use(VueCookies);

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueRouter)
Vue.use(browserDetect);

const router = new VueRouter({
  mode: 'history'
})

Vue.prototype.$GA = new GA()
new Vue({
  vuetify,
  i18n,
  router,
  render: (h) => h(App),
}).$mount('#app')